export default __webpack_public_path__ + "static/house-c5a0b60d0b548a59ed5f58d227584104.svg";